<template>
    <router-view class="px-2"></router-view>
</template>

<script>
    export default {
        name: 'AccountAddress'
    };
</script>
